import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  padding: 2rem 10rem 12rem;
`

export const PageTitle = styled.h2`
  font-size: 1.5rem;
  font-weight: 600;
  color: #111827;
`

export const Subtitle = styled.p`
  color: #6b7280;
  font-size: 0.875rem;
  margin: 0.25rem 0 0 0;
`

export const PageHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
`

export const HeaderActions = styled.div`
  display: flex;
  gap: 0.75rem;
`

export const PrimaryButton = styled.button`
  display: inline-flex;
  align-items: center;
  padding: 0.5rem 1rem;
  background-color: #2563eb;
  color: white;
  border: none;
  border-radius: 0.375rem;
  font-weight: 500;
  font-size: 0.875rem;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background-color: #1d4ed8;
  }
`

export const SecondaryButton = styled.button`
  display: inline-flex;
  align-items: center;
  padding: 0.5rem 1rem;
  background-color: white;
  color: #374151;
  border: 1px solid #d1d5db;
  border-radius: 0.375rem;
  font-weight: 500;
  font-size: 0.875rem;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background-color: #f9fafb;
  }
`

export const CardGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(
    auto-fill,
    minmax(${props => props.$minWidth || '280px'}, 1fr)
  );
  gap: 1.5rem;
`

export const Card = styled.div`
  background: white;
  border-radius: 0.5rem;
  box-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1);
  border: 1px solid #e5e7eb;
  padding: 1.5rem;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    box-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1);
    border-color: #3b82f6;
  }
`

export const CardTitle = styled.h3`
  font-size: 1.125rem;
  font-weight: 600;
  color: #111827;
  margin-bottom: ${props => props.$mb || '0.5rem'};
`

export const CardDescription = styled.p`
  color: #6b7280;
  font-size: 0.875rem;
  line-height: 1.4;
  margin-bottom: 1rem;
`

export const CardActions = styled.div`
  display: flex;
  gap: 0.5rem;
  justify-content: flex-end;
`

export const ActionButton = styled.button`
  padding: 0.25rem 0.75rem;
  font-size: 0.75rem;
  font-weight: 500;
  border-radius: 0.25rem;
  border: 1px solid #d1d5db;
  background: white;
  color: #374151;
  cursor: pointer;

  &:hover {
    background-color: #f9fafb;
  }

  ${props =>
    props.$variant === 'danger' &&
    `
    color: #dc2626;
    border-color: #fecaca;

    &:hover {
      background-color: #fef2f2;
    }
  `}
`

export const EmptyStateContainer = styled.div`
  text-align: center;
  padding: 4rem 2rem;
  background: white;
  border-radius: 0.5rem;
  border: 1px solid #e5e7eb;
`

export const EmptyStateIcon = styled.div`
  width: 3rem;
  height: 3rem;
  background-color: #f3f4f6;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 1rem;
  color: #9ca3af;
`

export const CheckboxGroup = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 0.75rem;
`

export const LoadingContainer = styled.div`
  padding: 2rem;
  text-align: center;
  color: #6b7280;
`

export const StatusBadge = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 0.25rem 0.75rem;
  border-radius: 9999px;
  font-size: 0.75rem;
  font-weight: 500;

  ${props =>
    props.$variant === 'success'
      ? `
    background-color: #dcfce7;
    color: #166534;
  `
      : props.$variant === 'warning'
      ? `
    background-color: #fef3c7;
    color: #92400e;
  `
      : props.$variant === 'danger'
      ? `
    background-color: #fef2f2;
    color: #dc2626;
  `
      : `
    background-color: #f3f4f6;
    color: #374151;
  `}
`

export const Fieldset = styled.fieldset`
  border: 1px solid #e5e7eb;
  border-radius: 0.5rem;
  padding: 1.5rem;
  margin: 0;
  background-color: #ffffff;
`

export const FieldsetTitle = styled.h4`
  font-size: 1.125rem;
  font-weight: 600;
  color: #111827;
  margin: 0 0 1rem 0;
`

export const Row = styled.div`
  display: grid;
  grid-template-columns: ${props => props.$columns || '1fr'};
  gap: 1rem;
  margin-bottom: 1rem;

  &:last-child {
    margin-bottom: 0;
  }
`

export const SideNote = styled.div`
  display: grid;
  grid-template-columns: 7fr 5fr;
  gap: 2rem;
  align-items: start;
  margin-bottom: 1.5rem;

  &:last-child {
    margin-bottom: 0;
  }
`

export const SideNoteText = styled.div`
  font-size: 0.875rem;
  color: #6b7280;
  line-height: 1.5;
  padding-top: 1.75rem;
`

export const CopyInputContainer = styled.div`
  display: flex;
  border: 1px solid #d1d5db;
  border-radius: 0.375rem;
  overflow: hidden;
`

export const CopyInput = styled.input`
  flex: 1;
  padding: 0.5rem 0.75rem;
  border: none;
  font-size: 0.875rem;
  background-color: #f9fafb;

  &:focus {
    outline: none;
  }
`

export const CopyButton = styled.button`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 0.75rem;
  background-color: #f3f4f6;
  border: none;
  border-left: 1px solid #d1d5db;
  font-size: 0.875rem;
  color: #374151;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background-color: #e5e7eb;
  }

  svg {
    width: 1rem;
    height: 1rem;
  }
`

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 2rem;
`

export const ColorGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(${props => props.$columns || 6}, 1fr);
  gap: ${props => props.$gap || '0.75rem'};
  margin-top: 0.5rem;
`

export const ColorOption = styled.button`
  width: ${props => props.$size || '3rem'};
  height: ${props => props.$height || '2rem'};
  border-radius: ${props => props.$radius || '0.375rem'};
  border: 2px solid ${props => (props.$selected ? '#3b82f6' : 'transparent')};
  background-color: ${props => props.color};
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    transform: scale(1.05);
  }
`

// Shared by the week editors: clinic week hours and appointment type booking
// rules. Both lay a week out as one row per day.
export const DayRow = styled.div`
  display: flex;
  align-items: ${props => props.$alignTop || 'center'};
  gap: 0.75rem;
  padding: 0.625rem 0;
  border-bottom: 1px solid #f3f4f6;

  &:last-child {
    border-bottom: none;
  }
`

export const DayLabel = styled.div`
  width: 90px;
  font-size: 0.875rem;
  font-weight: 600;
  color: #374151;
  text-transform: capitalize;
  flex-shrink: 0;
`

export const TimeFieldsRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-wrap: wrap;
`

export const TimeSeparator = styled.span`
  font-size: 0.8rem;
  color: #9ca3af;
`

// The columns below are what keep the two week editors reading as one screen:
// every cell that precedes the time fields has a fixed width, so the hours line
// up down the whole week no matter how much a row holds.
export const DayName = styled(DayLabel)`
  color: ${props => (props.$closed ? '#9ca3af' : '#374151')};
  padding-top: 0.5rem;
`

// Wide enough for the longer of the two toggle labels, so the hours column
// starts at the same offset whether a day reads "Open" or "Closed".
export const DayToggleCell = styled.div`
  width: 118px;
  flex-shrink: 0;
`

export const DayContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  min-width: 0;
`

export const DayHoursLine = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-wrap: wrap;
`

// Fixed width so whatever follows a range — a break toggle, a remove button —
// holds its own column too.
export const TimeRangeGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  width: 260px;
  flex-shrink: 0;
`

export const DayNote = styled.div`
  font-size: 0.8rem;
  color: #9ca3af;
  padding: 0.5rem 0;
`
